import type { MediaAnalyticsEvent } from './types.ts';

const EVENTS_LIMIT = 100;

export class LocalMediaAnalyticsSink {
  readonly events: MediaAnalyticsEvent[] = [];

  emit(event: MediaAnalyticsEvent): void {
    this.events.push(structuredClone(event));
    if (this.events.length > EVENTS_LIMIT) this.events.shift();
  }

  clear(): void {
    this.events.length = 0;
  }
}
